export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const LANDING = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const DASHBOARD = '/dashboard';
export const PASSWORD_FORGET = '/pw-forget';



// WEBPACK FOOTER //
// ./src/constants/routes.js